import { Component, inject, input, model, output, signal } from '@angular/core';
import { CardModule } from 'primeng/card';
import { PermissionsService } from '../services/permissions.service';
import { ProfileService } from '../../profile/services/profile.service';
import { RoutesService } from '../../shared/services/routes.service';
import { User } from '../../shared/models/user.model';
import { PermissionsModel } from '../../shared/models/permissions.model';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { access } from 'fs';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-permissions-list',
  standalone: true,
  imports: [
    CardModule,
    TableModule,
    ButtonModule,
    ButtonGroupModule,
    RippleModule,
    ChipModule,
  ],
  templateUrl: './permissions-list.component.html',
  styleUrl: './permissions-list.component.css'
})
export class PermissionsListComponent {
  protected service = inject(PermissionsService)
  protected routesService = inject(RoutesService)
  private profileService = inject(ProfileService)

  protected access = inject(AccessService).access
  protected resource = this.service.resource?.toLowerCase();

  public detailed = input<boolean>(true);

  protected value = model<PermissionsModel[]>()

  public length = output<number>()

  ngOnInit(): void {
    this.service.title.update((value) => 'Lista de Permisos')
    this.service.get().subscribe(data => {
      this.value.update(value => {
        value = data as PermissionsModel[];
        // console.log('value List: ', value)
        this.length.emit(value.length)
        return value;
      });
    })
  }
}
